import React from 'react';
import Icon from 'components/icon/Icon';

export default class KeywordFilter extends React.Component {

    // Validate data from props
    static propTypes = {
        keyword: React.PropTypes.string,
        filter: React.PropTypes.object.isRequired,
        placeholderText: React.PropTypes.string,
        updateKeyword: React.PropTypes.func.isRequired,
        classModifier: React.PropTypes.string
    };

    handleKeyPress = (e) => {
        // Pass the input value back to the update call back function when enter is pressed
        if (e.key === 'Enter') {
            this.props.updateKeyword.call(this, this.props.filter, e.target.value);
        }
    }

    handleChange = (e) => {
        this.props.updateKeyword.call(this, this.props.filter, e.target.value);
    }

    render() {
        return (
            <div className={`keyword-filter input-wrapper ${this.props.classModifier}`}>
                <input type="text" value={this.props.keyword} onChange={this.handleChange} onKeyPress={this.handleKeyPress} placeholder={this.props.placeholderText} />
                <Icon glyph='search' />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/keyword-filter/KeywordFilter.jsx
 **/